// import DataFetch from '../../Utility/data-fetch';
import Cookies from 'js-cookie';
import md5 from 'blueimp-md5';

const defaultTranslationCode = 'niv';
const preferenceCookieName = '__pref';
const prefPrefix = 'pref_';

const call = () => {
    return {
        translationCode: defaultTranslationCode,
        storage: window.localStorage,

        initPreferences() {
            let preferenceCookie = Cookies.get(preferenceCookieName);

            if (!preferenceCookie || preferenceCookie.length < 1) {
                Cookies.set(preferenceCookieName, this.generateMd5());
            }

            if (!this.storage.getItem(prefPrefix + 'translation')) {
                this.storage.setItem(prefPrefix + 'translation', defaultTranslationCode);
            }
        },
        generateMd5() {
            return md5(this.allStorage().toString());
        },
        read(key, def) {
            return this.storage.getItem(key) || def || false;
        },
        readPref(key, def) {
            this.initPreferences();
            return this.read(prefPrefix + key) || def || false;
        },
        write(key, value) {
            this.storage.setItem(key, value);
        },
        writePref(key, value) {
            this.write(prefPrefix + key, value);
            Cookies.set(preferenceCookieName, this.generateMd5());
        },
        remove(key) {
            this.storage.removeItem(key)
        },
        allStorage() {
            let values = [];
            let keys = Object.keys(localStorage);
            let i = keys.length;

            while (i--) {
                if (keys[i].startsWith(prefPrefix)) {
                    let item = localStorage.getItem(keys[i]);
                    values.push(item);
                }
            }

            return values;
        },
    };
};

export default call;